import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantRentalPage } from './merchant-rental';

@NgModule({
  declarations: [
    MerchantRentalPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantRentalPage),
    TranslateModule.forChild()
  ],
})
export class MerchantRentalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-rental/merchant-rental.module.ts